import {ValueListener} from "./interfaces";
import {observeRSVPQuestionsV2} from "./observeRSVPQuestionsV2";

export const observeDoesResponseWorkflowExist = (eventDataSource: any, listener: ValueListener<boolean>) => {

    listener = eventDataSource.wrapListener(listener);
    let rsvpQuestions, pageConfig;

    const compute = function () {
        if (!pageConfig.rsvp) return false;
        return rsvpQuestions.length > 0;
    };

    const onUpdate = function () {
        var anyUndef = ([rsvpQuestions, pageConfig].filter(x => (typeof x == "undefined")).length > 0);
        if (anyUndef) {
            return;
        }
        listener.onValue(compute());
    };

    observeRSVPQuestionsV2(eventDataSource, {onValue: function (q) {
        rsvpQuestions = q.asSortedArray().filter(q => q.isEnabled);
        onUpdate();
    }});

    eventDataSource.observePageConfig({onValue: function (dashboardConfig) {
        pageConfig = dashboardConfig;
        onUpdate();
    }});
};
